<router-outlet>
</router-outlet>
<ng-http-loader [backgroundColor]="'#00b600'" [spinner]="spinkit.skWave" [debounceDelay]="100" [minDuration]="300" [extraDuration]="300"
    [filteredUrlPatterns]="['api/account/refresh-access-token', 'api/account/check-request-status']">
</ng-http-loader>
<np-check-version></np-check-version>